module.exports = __webpack_public_path__ + "static/img/z1.5000fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/z1.png
// module id = cN+R
// module chunks = 1